import { ImgHTMLAttributes } from "react";
import { connect } from "react-redux";
import * as StoreTypes from "../AppointmentBooking/DataTypes/storeTypes";

interface IProps extends ImgHTMLAttributes<any> {
    cdnHost?: string;
}

const isAbsolute = (url: string): boolean => {
    const r = new RegExp("^(?:[a-z]+:)?//", "i");
    return r.test(url);
};

const ImageCdnized = (props: IProps) => {
    let { cdnHost, dispatch, src, ...imageProps } = props as any;

    if (!isAbsolute(src)) src = `${cdnHost}${src}`;

    return <img {...(imageProps as any)} src={src} />;
};

const mapStateToProps = (state: StoreTypes.IStore, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        cdnHost: state.initialSettings.cdnHost,
    };
};

export const Image = connect(mapStateToProps)(ImageCdnized);
